export default __webpack_public_path__ + "static/media/bg-welcome.91febcbe.png";